// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".err_404[data-v-1b0fc267] {\n  padding-top: 6.666667rem;\n  margin-top: 40%;\n  background: url('https://static.mingchu.co/m/images/eq/404@2x.png') center top no-repeat;\n  background-size: 6.666667rem 6.666667rem;\n  text-align: center;\n  font-size: 0.373333rem;\n  color: #b4b4b4;\n}", ""]);
// Exports
module.exports = exports;
